import { modalDetailPromoText } from 'Const/stock-promo/view';

import { TextRegular } from 'UiKit/typography';

import ColumnPriceDetail from 'View/stock-promo/component/columnPriceDetail';

import styles from './styles.module.css';

const tableList = [
  {
    name: modalDetailPromoText.columnBarcode,
    key: 'sku',
    position: 'left',
    component: ({ value, values }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{value}</TextRegular>;
    },
  },
  {
    name: modalDetailPromoText.columnProductName,
    key: 'name',
    position: 'left',
    component: ({ value, values }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{value}</TextRegular>;
    },
  },
  {
    name: modalDetailPromoText.columnPrice,
    key: 'price',
    position: 'left',
    component: ({ values }) => {
      return <ColumnPriceDetail data={values} />;
    },
  },
  {
    name: modalDetailPromoText.columnRemainingStock,
    key: 'remainingStock',
    position: 'left',
    labelInfo: 'Jumlah stok yang masih tersedia untuk promo ini',
    component: ({ value }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{value}</TextRegular>;
    },
  },
  {
    name: modalDetailPromoText.columnAllocationStock,
    key: 'allocatedStock',
    position: 'left',
    labelInfo: 'Total stok yang telah dialokasikan untuk promo ini',
    component: ({ value }) => {
      return <TextRegular className={`${styles['modal__table--col-text']}`}>{value}</TextRegular>;
    },
  },
];
export default tableList;
